var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.eventsByDays),function(e){return _c('div',{key:e.id},[(e.isDate)?_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.formatDate(e.date)))]):_c('PetEvent',{attrs:{"event":e},on:{"click":function($event){return _vm.$emit('click', e)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }